/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'ornate',
    quality: 0.6,
    learning: 1,
    perception: 2,
    dexterity: 3
}